import React, { useState } from 'react';
import { analizBaslat, analizDurum } from '../../services/reklamApi';

const bugunISO = () => new Date().toISOString().slice(0, 10);
const ayBasiISO = () => { const d = new Date(); d.setDate(1); return d.toISOString().slice(0, 10); };

// Reklam Yönetimi'nin ilk alt sekmesi — kullanıcı talebi: 2026-08-12 ("REKLAM YÖNETİMİ alt
// menüsü tasarlasak, Dönem Analizi bunun ilk unsuru olarak yerini alsa"). Önceden tek sayfa
// olan ReklamYonetimi.js'ten ayrıştırıldı, sayfa başlığı ve bağlantı durumu artık üst
// çerçevede (ReklamYonetimi.js), burada sadece bu sekmenin kendi içeriği var.
export default function DonemAnalizi() {
  const [donemBaslangic, setDonemBaslangic] = useState(ayBasiISO());
  const [donemBitis, setDonemBitis] = useState(bugunISO());
  const [donemDurum, setDonemDurum] = useState('bos'); // bos | yukleniyor | hazir | hata
  const [donemVerisi, setDonemVerisi] = useState(null);
  const [donemHata, setDonemHata] = useState('');
  const [donemSure, setDonemSure] = useState(null); // saniye, gerçekten ne kadar sürdüğünü göstermek için

  // DIŞLAYICI ACCORDION — kullanıcı talebi: 2026-08-16 ("bir kırılımı açtığımda diğerleri
  // kapansın, odaklandığım detay kalsın"). Aynı anda tek kampanya ve o kampanyanın içinde tek
  // set açık olur. Veri baştan yüklendiği için açma/kapama anlıktır, sunucuya gidilmez.
  const [acikKampanya, setAcikKampanya] = useState(null);
  const [acikSet, setAcikSet] = useState(null);

  const kampanyaAc = (id) => {
    setAcikKampanya(prev => (prev === id ? null : id));
    setAcikSet(null);   // kampanya değişince alt seviye kapanır
  };
  const setAc = (id) => setAcikSet(prev => (prev === id ? null : id));

  // İLERLEME ÇUBUĞU — kullanıcı talebi: 2026-08-16. Artık TAHMİN DEĞİL, GERÇEK: analiz arka
  // planda çalışıyor, ekran 600 ms'de bir "neredesin" diye soruyor ve sunucunun bildirdiği
  // aşamayı/yüzdeyi gösteriyor.
  //
  // Not: kampanya bazlı ilerleme mümkün değil — Meta tüm kampanyaları tek çağrıda döndürüyor,
  // tek tek taranmıyorlar. Bu yüzden ilerleme gerçek iş adımlarına göre bölünmüş durumda; en
  // yavaş kısım olan klinik taraması 4 şubeye bölündüğü için çubuk orada dörder dörder ilerler.
  const [ilerleme, setIlerleme] = useState(0);
  const [asama, setAsama] = useState('');
  const [gecenSure, setGecenSure] = useState(0);

  const donemAnalizEt = () => {
    if (!donemBaslangic || !donemBitis) return;
    setDonemDurum('yukleniyor');
    setDonemSure(null);
    setIlerleme(0);
    setAsama('Başlatılıyor...');
    setGecenSure(0);

    const baslangicZamani = performance.now();
    const sureSayaci = setInterval(() => setGecenSure((performance.now() - baslangicZamani) / 1000), 200);

    const bitir = () => {
      clearInterval(sureSayaci);
      setDonemSure(((performance.now() - baslangicZamani) / 1000).toFixed(1));
    };

    analizBaslat(donemBaslangic, donemBitis)
      .then(res => {
        const isId = res.data.isId;
        const sorgula = setInterval(() => {
          analizDurum(isId)
            .then(d => {
              setIlerleme(d.data.yuzde);
              setAsama(d.data.asama);
              if (!d.data.tamamlandi) return;

              clearInterval(sorgula);
              bitir();
              if (d.data.hataMesaji) { setDonemHata(d.data.hataMesaji); setDonemDurum('hata'); }
              else { setIlerleme(100); setDonemVerisi(d.data.sonuc); setDonemDurum('hazir'); }
            })
            .catch(err => {
              clearInterval(sorgula); bitir();
              setDonemHata(err.response?.data?.hata || err.message);
              setDonemDurum('hata');
            });
        }, 600);
      })
      .catch(err => {
        bitir();
        setDonemHata(err.response?.data?.hata || err.message || 'Bilinmeyen hata');
        setDonemDurum('hata');
      });
  };

  const paraFormat = (v) => v == null ? '-' : `${Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
  const yuzdeFormat = (v) => v == null ? '-' : `%${Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  // Dönüşüm Oranı (Meta Form / Gösterim) doğası gereği çok küçük (%0,01-%0,15 arası) — 2 ondalık
  // basamak bu aralıkta kampanyalar arası gerçek farkı gizliyordu, 3'e çıkarıldı. Kullanıcı talebi:
  // 2026-08-12 ("hesap makinesi kullanmadan göremiyorum").
  const yuzdeFormatHassas = (v) => v == null ? '-' : `%${Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`;
  const sayiFormat = (v) => v == null ? '-' : Number(v).toLocaleString('tr-TR');
  const tarihFormat = (v) => v ? new Date(v).toLocaleDateString('tr-TR') : '-';
  // Kampanya adlarının başındaki emoji/simge önekleri (👉 🔻 /// ++ vb.) hesabı yöneten kişinin
  // kendi düzenleme işaretleri, iş anlamı taşımıyor — ekranda gösterirken temizlenir (kullanıcı
  // talebi: 2026-08-12). "ŞKR" gibi harf tabanlı önekler harf olduğu için etkilenmez.
  const kampanyaAdiTemizle = (ad) => (ad || '').replace(/^[^\p{L}\p{N}]+/u, '').trim();
  // Genel --border tonu (#e5e9e8) tabloda hücreleri ayırmak için çok soluktu — kullanıcı
  // talebi: 2026-08-12 ("çerçeveleri daha belirgin yap"). Sadece bu tabloya özel, daha koyu bir ton.
  const HUCRE_CERCEVE = '1px solid #b8c4c2';
  // Sütun başlıklarına açıklama — sabit alt-metin yerine tooltip (kullanıcı talebi: 2026-08-12,
  // "tablo şişmesin"). Noktalı alt çizgi, üzerine gelince açıklama olduğunu belli ediyor.
  const IPUCU_BASLIK = { textDecoration: 'underline', textDecorationStyle: 'dotted', textDecorationColor: '#8a9997', cursor: 'help' };

  return (
    <div>
      <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>Kullanıcı Analizi</h3>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 10 }}>
        Serbest dönem seçip kendi ölçümlerinizi yaptığınız alan — öneri üretilmez, eşik uygulanmaz.
        Sistemin kendi kararlarını <strong>Yapay Zeka Analizi</strong> sekmesinde izlersiniz.
      </div>
      <div style={{
        background: '#fff', border: '1px solid var(--border)', borderRadius: 8,
        marginBottom: 20, overflow: 'hidden',
      }}>
        <div style={{ padding: 16, display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap', borderBottom: '1px solid var(--border)' }}>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Başlangıç</div>
            <input type="date" value={donemBaslangic} onChange={e => setDonemBaslangic(e.target.value)}
              style={{ border: '1px solid var(--border)', borderRadius: 6, padding: '6px 8px', fontSize: 13 }} />
          </div>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Bitiş</div>
            <input type="date" value={donemBitis} onChange={e => setDonemBitis(e.target.value)}
              style={{ border: '1px solid var(--border)', borderRadius: 6, padding: '6px 8px', fontSize: 13 }} />
          </div>
          <button onClick={donemAnalizEt} disabled={donemDurum === 'yukleniyor'} style={{
            background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 6,
            padding: '8px 16px', fontSize: 13, fontWeight: 600,
            cursor: donemDurum === 'yukleniyor' ? 'default' : 'pointer',
            opacity: donemDurum === 'yukleniyor' ? 0.6 : 1,
          }}>
            {donemDurum === 'yukleniyor' ? '⏳ Analiz ediliyor...' : '🔍 Analiz Et'}
          </button>
          {donemSure && donemDurum !== 'yukleniyor' && (
            <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Son sorgu: {donemSure} sn</span>
          )}
        </div>

        {donemDurum === 'yukleniyor' && (
          <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)' }}>
            <div style={{ height: 8, background: '#EDF1F0', borderRadius: 4, overflow: 'hidden' }}>
              <div style={{
                width: `${ilerleme}%`, height: '100%', background: '#1D9E75',
                borderRadius: 4, transition: 'width 200ms linear',
              }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, fontSize: 11, color: 'var(--text-muted)' }}>
              <span>{asama}</span>
              <span>%{ilerleme} · {gecenSure.toFixed(0)} sn</span>
            </div>
          </div>
        )}

        {donemDurum === 'bos' && (
          <div style={{ padding: 16, color: 'var(--text-muted)', fontSize: 13 }}>
            Tarih aralığı seçip "Analiz Et"e basın — Meta'dan harcama, veritabanından (14 Mayıs'tan bugüne, sadece o kadarını görebiliyoruz) CallCenter sonucu birlikte gelir. Genelde birkaç saniye sürer.
          </div>
        )}
        {donemDurum === 'hata' && (
          <div style={{ padding: 16, color: '#D9534F', fontSize: 13 }}>● {donemHata}</div>
        )}
        {donemDurum === 'hazir' && donemVerisi?.kampanyalar?.length === 0 && (
          <div style={{ padding: 16, color: 'var(--text-muted)', fontSize: 13 }}>
            Bu tarih aralığında hiçbir kampanyada harcama/aktivite bulunamadı.
          </div>
        )}
        {donemDurum === 'hazir' && donemVerisi?.kampanyalar?.length > 0 && (() => {
          const kk = donemVerisi.kampanyalar;
          const toplamHarcama = kk.reduce((t, k) => t + (k.harcama || 0), 0);
          const toplamGosterim = kk.reduce((t, k) => t + (k.gosterim || 0), 0);
          const toplamTiklama = kk.reduce((t, k) => t + (k.tiklama || 0), 0);
          const toplamLinkTiklamasi = kk.reduce((t, k) => t + (k.linkTiklamasi || 0), 0);
          const toplamMetaForm = kk.reduce((t, k) => t + (k.metaFormGonderimi || 0), 0);
          // 2026-08-16: Meta'nın lead kaydı hangi reklamdan geldiğini taşıdığı için her kampanya
          // KENDİ sonucunu gösteriyor. Eski "form grubu" tekilleştirmesi ve birleşik hücreler
          // kaldırıldı — artık düz toplama yapılabiliyor.
          const toplamOlumlu = kk.reduce((t, k) => t + (k.beniaraOlumlu || 0), 0);
          const toplamLead = kk.reduce((t, k) => t + (k.beniaraLeadSayisi || 0), 0);
          const toplamIslemYaptiran = kk.reduce((t, k) => t + (k.islemYaptiran || 0), 0);
          const toplamCiro = kk.reduce((t, k) => t + (k.islemCiro || 0), 0);
          // NET KATKI (2026-08-20): patron hizmet maliyet oranlarını girdi (%30), artık bu
          // ekranda da ham ciro değil CEBE KALAN konuşulabiliyor.
          const toplamNetKatki = kk.reduce((t, k) => t + (k.islemNetKatki || 0), 0);
          const toplamHizmetMaliyeti = kk.reduce((t, k) => t + (k.islemMaliyet || 0), 0);
          const toplamIslemOrani = toplamLead > 0 ? (toplamIslemYaptiran / toplamLead) * 100 : null;
          // Toplam Dönüşüm Oranı / Olumlu Oranı satır bazındaki değerlerin ortalaması DEĞİL,
          // toplamlardan yeniden hesaplanır (ağırlıklı) — aksi halde kampanyalar eşit ağırlıkta
          // sayılıp yanıltıcı bir "ortalama" çıkar. Kullanıcı talebi: 2026-08-12.
          // Dönüşüm Oranı = Meta Form / Gösterim — "182.645 gösterimden kaçı elime geçti" sorusunun
          // doğrudan cevabı (kullanıcı talebi: 2026-08-12). Eskiden Genel Tıklama/Gösterim'di (CTR) —
          // o teşhis amaçlı hâlâ hesaplanabilir (Genel Tıklama sütunu duruyor) ama artık ayrı bir
          // sütun olarak gösterilmiyor, patronun asıl merak ettiği bu.
          const toplamDonusumOrani = toplamGosterim > 0 ? (toplamMetaForm / toplamGosterim) * 100 : null;
          const toplamOlumluOrani = toplamLead > 0 ? (toplamOlumlu / toplamLead) * 100 : null;

          // Sıralama artık düz: en çok harcayan üstte. Grup bitişikliği derdi kalmadı.
          const siraliKampanyalar = [...kk].sort((a, b) => b.harcama - a.harcama);

          return (
            <>
              <div style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', fontSize: 12, color: 'var(--text-muted)' }}>
                <strong>{tarihFormat(donemVerisi.baslangic)} — {tarihFormat(donemVerisi.bitis)}</strong> arası toplam —
                {' '}{donemVerisi.kampanyaSayisi} kampanya, toplam harcama {paraFormat(donemVerisi.toplamHarcama)}
              </div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: '#fafafa', textAlign: 'left' }}>
                      <th style={{ padding: '8px 12px', border: HUCRE_CERCEVE }}>Kampanya</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>Harcama</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Reklamınızın kaç kez ekranda görüntülendiği.">Gösterim</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Reklama yapılan HER türlü dokunma — fotoğraf büyütme, beğenme dahil. Formla ilgisi olmayabilir.">Genel Tıklama</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Gerçekten bir yere giden tıklama — forma açılmaya en yakın olan bu.">Link Tıklaması</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Formu doldurup gönderen kişi sayısı (Meta'nın kendi sayımı).">Meta Form</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Gösterimden kaçı gerçekten forma dönüştü — Meta Form ÷ Gösterim.">Dönüşüm Oranı</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Form dolduranlardan kaçı aranıp gerçek hastaya/randevuya dönüştü.">CallCenter Sonucu</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Randevu verilenlerin kaçı GERÇEKTEN kliniğe gelip işlem yaptırdı — klinik veritabanlarındaki (4 şube) işlem kayıtlarından bulunur, randevu kaydından değil.">İşlem Yaptırma Oranı</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE, ...IPUCU_BASLIK }} title="Bu lead'lerin lead tarihinden BUGÜNE kadar bıraktığı toplam para (KDV dahil). Reklam bittikten sonra da gelmeye devam ettikleri için bu rakam zamanla büyür.">Getiri</th>
                    </tr>
                  </thead>
                  <tbody>
                    {siraliKampanyalar.map((k, sira) => {
                      // Dışlayıcı accordion: aynı anda tek kampanya açık. Alt satırlar aynı
                      // tabloda, girintili ve renkli olarak görünür.
                      //
                      // RENK KURALI (kullanıcı talebi: 2026-08-16): her kampanyanın kendi rengi
                      // var; setleri o rengin bir açık tonu, reklamları ise setin bir açık tonu.
                      // Böylece hangi satırın hangi kampanyaya ait olduğu renkten okunuyor.
                      // Ton, kampanya sırasından türetiliyor — 47° adım renk çarkında iyi dağılım verir.
                      const ton = (sira * 47) % 360;
                      const zeminKampanya = `hsl(${ton}, 48%, 86%)`;
                      const zeminSet = `hsl(${ton}, 48%, 92%)`;
                      const zeminReklam = `hsl(${ton}, 48%, 97%)`;
                      const kenarKampanya = `hsl(${ton}, 55%, 42%)`;
                      const kenarSet = `hsl(${ton}, 50%, 60%)`;
                      const kenarReklam = `hsl(${ton}, 45%, 78%)`;

                      const acik = acikKampanya === k.metaKampanyaId;
                      const hastaBasiMaliyet = k.islemYaptiran > 0 ? k.harcama / k.islemYaptiran : null;
                      const H = { padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE };
                      const altH = { padding: '6px 12px', textAlign: 'right', border: HUCRE_CERCEVE, fontSize: 12 };

                      // Alt seviye satırı (set veya reklam) — aynı sütun düzeni.
                      const AltSatir = (d, derinlik, tiklama, aciksa) => {
                        const zemin = derinlik === 1 ? zeminSet : zeminReklam;
                        const kenar = derinlik === 1 ? kenarSet : kenarReklam;
                        const acilabilir = typeof tiklama === 'function';
                        return (
                          <tr key={`${derinlik}-${d.id}`} style={{ background: zemin }}>
                            <td style={{ padding: '6px 12px', border: HUCRE_CERCEVE, borderLeft: `4px solid ${kenar}`, paddingLeft: 12 + derinlik * 22, fontSize: 12 }}>
                              <span onClick={() => acilabilir && tiklama(d.id)}
                                    style={{ cursor: acilabilir ? 'pointer' : 'default', userSelect: 'none', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                {acilabilir ? (
                                  <span style={{
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    width: 20, height: 20, borderRadius: 4, fontSize: 11, fontWeight: 700,
                                    background: '#fff', border: `1px solid ${kenar}`, color: kenarKampanya,
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                                  }}>{aciksa ? '−' : '+'}</span>
                                ) : <span style={{ width: 20, display: 'inline-block' }} />}
                                {d.ad || d.id}
                              </span>
                            </td>
                            <td style={altH}>{paraFormat(d.harcama)}</td>
                            <td style={altH}>{sayiFormat(d.gosterim)}</td>
                            <td style={altH}>{sayiFormat(d.tiklama)}</td>
                            <td style={altH}>{sayiFormat(d.linkTiklamasi)}</td>
                            <td style={altH}>{sayiFormat(d.metaFormGonderimi)}</td>
                            <td style={altH}>{yuzdeFormatHassas(d.gosterim > 0 ? (d.metaFormGonderimi / d.gosterim) * 100 : null)}</td>
                            <td style={altH}>
                              {d.beniaraLeadSayisi === 0 ? <span style={{ color: '#c9d1d0' }}>-</span> : (
                                <>{yuzdeFormat(d.beniaraOlumluOrani)} olumlu
                                  <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>
                                    ({sayiFormat(d.beniaraOlumlu)} / {sayiFormat(d.beniaraLeadSayisi)})
                                  </div>
                                </>
                              )}
                            </td>
                            <td style={altH}>
                              {d.beniaraLeadSayisi === 0 ? <span style={{ color: '#c9d1d0' }}>-</span> : (
                                <>{yuzdeFormat(d.islemOrani)} işlem
                                  <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>
                                    ({sayiFormat(d.islemYaptiran)} / {sayiFormat(d.beniaraLeadSayisi)})
                                  </div>
                                </>
                              )}
                            </td>
                            <td style={altH}>
                              {d.islemCiro > 0 ? paraFormat(d.islemCiro) : <span style={{ color: '#c9d1d0' }}>-</span>}
                            </td>
                          </tr>
                        );
                      };

                      const satirlar = [
                        <tr key={k.metaKampanyaId} style={{ background: zeminKampanya }}>
                          <td style={{ padding: '8px 12px', border: HUCRE_CERCEVE, borderLeft: `5px solid ${kenarKampanya}` }}>
                            <span onClick={() => kampanyaAc(k.metaKampanyaId)}
                                  style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                              {(k.setler && k.setler.length > 0) ? (
                                <span style={{
                                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                  width: 22, height: 22, borderRadius: 5, fontSize: 13, fontWeight: 700,
                                  background: '#fff', border: `1.5px solid ${kenarKampanya}`, color: kenarKampanya,
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                                }}>{acik ? '−' : '+'}</span>
                              ) : <span style={{ width: 22, display: 'inline-block' }} />}
                              <strong>{kampanyaAdiTemizle(k.kampanyaAdi) || k.metaKampanyaId}</strong>
                              {k.setler && k.setler.length > 0 && (
                                <span style={{ fontSize: 11, color: '#5A6B78' }}>({k.setler.length} set)</span>
                              )}
                            </span>
                          </td>
                          <td style={H}>{paraFormat(k.harcama)}</td>
                          <td style={H}>{sayiFormat(k.gosterim)}</td>
                          <td style={H}>{sayiFormat(k.tiklama)}</td>
                          <td style={H}>{sayiFormat(k.linkTiklamasi)}</td>
                          <td style={H}>{sayiFormat(k.metaFormGonderimi)}</td>
                          <td style={H}>
                            {yuzdeFormatHassas(k.gosterim > 0 ? (k.metaFormGonderimi / k.gosterim) * 100 : null)}
                          </td>
                          <td style={{ ...H, fontWeight: 600 }}>
                            {k.beniaraLeadSayisi === 0 ? (
                              <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontStyle: 'italic' }}>lead yok</span>
                            ) : (
                              <>
                                {yuzdeFormat(k.beniaraOlumluOrani)} olumlu
                                <div style={{ fontWeight: 400, fontSize: 11, color: 'var(--text-muted)' }}>
                                  ({sayiFormat(k.beniaraOlumlu)} / {sayiFormat(k.beniaraLeadSayisi)} lead)
                                </div>
                              </>
                            )}
                          </td>
                          <td style={{ ...H, fontWeight: 600 }}>
                            {k.beniaraLeadSayisi === 0 ? (
                              <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontStyle: 'italic' }}>-</span>
                            ) : (
                              <>
                                {yuzdeFormat(k.islemOrani)} işlem
                                <div style={{ fontWeight: 400, fontSize: 11, color: 'var(--text-muted)' }}>
                                  ({sayiFormat(k.islemYaptiran)} / {sayiFormat(k.beniaraLeadSayisi)} kişi)
                                </div>
                              </>
                            )}
                          </td>
                          <td style={{ ...H, fontWeight: 600 }}>
                            {k.islemCiro > 0 ? paraFormat(k.islemCiro) : <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontStyle: 'italic' }}>-</span>}
                            {k.islemNetKatki > 0 && (
                              <div style={{ fontWeight: 600, fontSize: 11.5, color: k.islemNetKatki >= k.harcama ? '#1D7A56' : '#C0392B' }}>
                                net katkı {paraFormat(k.islemNetKatki)}
                              </div>
                            )}
                            {hastaBasiMaliyet != null && (
                              <div style={{ fontWeight: 400, fontSize: 11, color: 'var(--text-muted)' }}>
                                hasta başı maliyet {paraFormat(hastaBasiMaliyet)}
                              </div>
                            )}
                          </td>
                        </tr>
                      ];

                      if (acik && k.setler) {
                        k.setler.forEach(s => {
                          const setAcik = acikSet === s.ust.id;
                          satirlar.push(AltSatir(s.ust, 1, setAc, setAcik));
                          if (setAcik) s.reklamlar.forEach(r => satirlar.push(AltSatir(r, 2, null, false)));
                        });
                      }

                      return satirlar;
                    })}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: '#fafafa', fontWeight: 700 }}>
                      <td style={{ padding: '8px 12px', border: HUCRE_CERCEVE }}>TOPLAM</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{paraFormat(toplamHarcama)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{sayiFormat(toplamGosterim)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{sayiFormat(toplamTiklama)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{sayiFormat(toplamLinkTiklamasi)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{sayiFormat(toplamMetaForm)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{yuzdeFormatHassas(toplamDonusumOrani)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{yuzdeFormat(toplamOlumluOrani)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{yuzdeFormat(toplamIslemOrani)}</td>
                      <td style={{ padding: '8px 12px', textAlign: 'right', border: HUCRE_CERCEVE }}>{paraFormat(toplamCiro)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div style={{ padding: '8px 16px', fontSize: 11, color: 'var(--text-muted)', borderTop: '1px solid var(--border)' }}>
                Her kampanya <strong>kendi</strong> sonucunu gösterir — aynı formu paylaşan kampanyalar bile ayrışır,
                çünkü Meta her lead'in hangi reklamdan geldiğini kaydeder.
                {' '}<strong>İşlem Yaptırma Oranı</strong> ve <strong>Getiri</strong>, hastanın kliniğe gerçekten gelip gelmediğini 4 şubenin veritabanından okur (randevu kaydından değil). Getiri lead tarihinden BUGÜNE kadar birikir — aynı dönemi aylar sonra tekrar sorgularsanız rakam büyümüş, hasta başı maliyet düşmüş olur.
              </div>

              {/* Tablonun düz Türkçe özeti — kullanıcı talebi: 2026-08-14. Tabloyu okumadan
                  "kâr mı zarar mı" sorusunun cevabı. Rakamlar TOPLAM satırıyla aynı kaynaktan
                  gelir (grup tekrarları tekilleştirilmiş). */}
              {(() => {
                // Reklamı görüp form doldurmadan doğrudan arayanlar — kullanıcı talebi: 2026-08-14.
                // Kampanya bazında dağıtılamaz (Meta'da lead kaydı yok), sadece toplama eklenir.
                // Aynı kişi hem form doldurup hem aradıysa burada sayılmaz, çift sayım olmaz.
                const elle = donemVerisi.elleGirilen || {};
                const elleCiro = elle.ciro || 0;
                const genelCiro = toplamCiro + elleCiro;
                // KÂR/ZARAR NET KATKIDAN HESAPLANIR (2026-08-20). Maliyet oranları girilmeden
                // önce ham ciro tek ölçüydü; ikisini karıştırmak yanlış rakam üretiyordu —
                // ekran "cebe kalan 92.296 ₺" derken "7.233 ₺ geridesiniz" diyordu, o fark ham
                // cirodan hesaplanmıştı. Maliyet girilmemişse eski davranış sürer.
                const maliyetVar = toplamHizmetMaliyeti > 0;
                const kiyasDegeri = maliyetVar ? toplamNetKatki + elleCiro : genelCiro;
                const fark = kiyasDegeri - toplamHarcama;
                const genelIslemYaptiran = toplamIslemYaptiran + (elle.islemYaptiran || 0);
                const geriDonus = toplamHarcama > 0 ? kiyasDegeri / toplamHarcama : null;
                const hastaBasiMaliyet = genelIslemYaptiran > 0 ? toplamHarcama / genelIslemYaptiran : null;
                const hastaBasiCiro = genelIslemYaptiran > 0 ? genelCiro / genelIslemYaptiran : null;
                // 1 ₺ karşılığı 1 ₺'nin altındaysa "kuruş" demek daha anlaşılır; üstündeyse ₺.
                const birLiraKarsiligi = geriDonus == null ? '-'
                  : geriDonus < 1 ? `${Math.round(geriDonus * 100)} kuruş`
                  : paraFormat(geriDonus);
                const kardaMi = fark >= 0;
                return (
                  <div style={{
                    margin: 16, padding: 16, borderRadius: 8, fontSize: 14, lineHeight: 1.7,
                    background: kardaMi ? '#EAF6F0' : '#FFF6E5',
                    border: `1px solid ${kardaMi ? '#9FD3BB' : '#E8C468'}`,
                  }}>
                    <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 13, letterSpacing: 0.3 }}>ÖZET</div>
                    <div>
                      Bu dönemde reklama <strong>{paraFormat(toplamHarcama)}</strong> harcadınız.<br />
                      Bu reklamlardan gelen hastalar bugüne kadar size <strong>{paraFormat(genelCiro)}</strong> ciro bıraktı.<br />
                      {toplamHizmetMaliyeti > 0 && (
                        <>
                          Hizmet maliyeti düşülünce cebe kalan: <strong>{paraFormat(toplamNetKatki)}</strong>
                          {' '}(maliyet {paraFormat(toplamHizmetMaliyeti)}).<br />
                        </>
                      )}
                      Şu an <strong style={{ color: kardaMi ? '#1D7A56' : '#C0392B' }}>
                        {paraFormat(Math.abs(fark))} {kardaMi ? 'öndesiniz' : 'geridesiniz'}
                      </strong> — yani harcadığınız 1 ₺, bugün itibarıyla <strong>{birLiraKarsiligi}</strong> geri döndürmüş.
                      {maliyetVar && (
                        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                          {' '}(hesap net katkı üzerinden; ham ciroya göre bakılsaydı
                          {' '}{paraFormat(Math.abs(genelCiro - toplamHarcama))}
                          {' '}{genelCiro >= toplamHarcama ? 'önde' : 'geride'} görünürdü)
                        </span>
                      )}
                    </div>
                    <div style={{ marginTop: 12 }}>
                      <strong>Kaba karşılığı:</strong><br />
                      {sayiFormat(toplamLead)} kişi form doldurdu,<br />
                      {sayiFormat(toplamOlumlu)}'ine randevu verildi,<br />
                      {sayiFormat(toplamIslemYaptiran)}'i gelip işlem yaptırdı.<br />
                      {elle.kisi > 0 && (
                        <>
                          Ayrıca <strong>{sayiFormat(elle.kisi)}</strong> kişi form doldurmadan doğrudan aradı
                          {' '}(personel elle kaydetti), <strong>{sayiFormat(elle.islemYaptiran || 0)}</strong>'i işlem yaptırdı
                          {' '}ve <strong>{paraFormat(elleCiro)}</strong> bıraktı — yukarıdaki toplama dahildir.<br />
                        </>
                      )}
                      {hastaBasiMaliyet != null && (
                        <>
                          Her hastayı ortalama <strong>{paraFormat(hastaBasiMaliyet)}</strong>'ye aldınız,<br />
                          o hastalar ortalama <strong>{paraFormat(hastaBasiCiro)}</strong> ciro bıraktı
                          {maliyetVar && genelIslemYaptiran > 0 && (
                            <>, maliyet düşülünce <strong>{paraFormat(kiyasDegeri / genelIslemYaptiran)}</strong> kaldı</>
                          )}.
                        </>
                      )}
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: 'var(--text-muted)' }}>
                      Bu bir fotoğraf, kader değil: bu dönemin hastaları gelmeye devam ettikçe ciro artar, hasta başı maliyet düşer.
                      {!kardaMi && hastaBasiCiro > 0 && (
                        <> Başabaşa gelmek için {paraFormat(Math.abs(fark))} daha ciro gerekiyor — bugünkü ortalamayla {sayiFormat(Math.ceil(Math.abs(fark) / hastaBasiCiro))} hasta daha, ya da mevcut hastaların tekrar gelmesi.</>
                      )}
                    </div>
                  </div>
                );
              })()}
            </>
          );
        })()}
      </div>
    </div>
  );
}
